<template>
  <div class="fff" v-if="projectList&&projectList.length>0">
    <Aside></Aside>
    <Header />
    <div class="banner" :style="`background:url(${projectList[$route.query.index].project_banner}) no-repeat center/cover`">
      <div class="background">
        <div class="menu">
          <div :class="['menu-item',showHtml == background ?'active':'']" @click="showHtml = background">培训背景</div>
          <div :class="['menu-item',showHtml == projectList[$route.query.index].target?'active':'']" @click="showHtml = projectList[$route.query.index].target">培训目标</div>
        </div>
        <div class="content" v-html="showHtml">
        </div>
      </div>
    </div>
    <div class="container">
      <div class="arrange">
        <div class="header"></div>
        <div class="content">
          <div class="item">
            <div class="num">01</div>
            <div class="info">
              <div class="name">报名阶段</div>
              <div class="description">全年接受报名<a href="https://www.jiaoyu.cn/need" target="_blank">联系我们</a></div>
            </div>
          </div>

          <div class="item">
            <div class="num">02</div>
            <div class="info">
              <div class="name">学习网课</div>
              <div class="description">电脑端、手机端在线看课</div>
            </div>
          </div>

          <div class="item">
            <div class="num">03</div>
            <div class="info">
              <div class="name">结业考试</div>
              <div class="description">线上无纸化考试、客观题型</div>
            </div>
          </div>

          <div class="item">
            <div class="num">04</div>
            <div class="info">
              <div class="name">完成培训</div>
              <div class="description">达到培训要求、完成培训</div>
            </div>
          </div>
        </div>
        <div class="bg"></div>
      </div>
      <div class="expert">
        <div class="expert-container">
          <div class="header"></div>
          <div class="content-swiper">
            <swiper :options="swiperOption">
              <swiper-slide v-for="item,index in swiperData" :key="index">
                <div class="expert-block">
                  <div class="block-cover" :style="`background:url(${item.cover}) no-repeat center/cover`"></div>
                  <div class="block-name">{{ item.name }}</div>
                  <div class="block-cont">
                    <div class="cont-header">
                      <div class="cont-school">{{ item.school_name }}</div>
                      <div class="cont-position">{{ item.position }}</div>
                    </div>
                    <div class="cont-body">
                      <div class="normal-title">
                        <span>{{ item.title }}</span>
                        <div class="hover-text">{{ item.description }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next">
          </div>
          <div class="swiper-button-prev">
          </div>
        </div>
      </div>
      <div class="course">
        <div class="header"></div>
        <div class="collect">
          <span>课程数 · {{courseInfo.total}}门</span>
          &nbsp;&nbsp;&nbsp;
          <span>课程总时长 · {{ courseInfo.total_time && ( Number(courseInfo.total_time.split(":")[0]) + "小时" + Number(courseInfo.total_time.split(":")[1]) + "分钟" ) }}</span>
        </div>
        <div class="category-list">
          <div :class="['item',item.id == categoryId?'active':'']" v-for="item,index in categoryData" :key="index" @click="currentId(item)">{{ item.name }}</div>
        </div>
        <div class="course-list">
          <div class="item" v-for="item,index in courseData" :key="index" @click="jumpDetail(item.id)">
            <div class="item-cover">
              <img :src="item.photo">
            </div>
            <div class="item-info">
              <div class="info-title"><span>{{ item.name }}</span></div>
              <div class="info-other">
                <el-tooltip effect="dark" :content="item.category_name" placement="bottom">
                  <div class="category">{{ item.category_name }}</div>
                </el-tooltip>
                <div class="time">{{item.total_time && ( Number(item.total_time.split(":")[0]) + "小时" + Number(item.total_time.split(":")[1]) + "分钟" )}}</div>
              </div>
            </div>
          </div>
          <div class="visible"></div>
          <div class="visible"></div>
        </div>
      </div>
      <div class="about">
        <div class="container">
          <div class="label">相关推荐</div>
          <div class="content">
            <template v-for="item,index in projectList">
              <a v-if="index != $route.query.index" target="_blank" :href="`/center/${school_code}/custom/party/project?index=${projectList.findIndex((i, j) => j == index)}`" :key="index">
                <img :src="item.cover">
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
import services from "../../../config/services"
import utils from "../../../config/utils"
import { mapState } from "vuex"
import projectData from "../../../assets/js/projectData.js"
import Aside from "../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      showHtml: "",
      background: "<p>为学习贯彻习近平新时代中国特色社会主义思想和党的二十大精神，深入贯彻落实新时代党的建设总体要求，做好新时代党员发展和教育工作，根据《中国共产党章程》《中国共产党党员教育管理工作条例》《中国共产党发展党员工作细则》《普通高等学校学生党建工作标准》等有关政策文件要求，助力院校高质量推进党的建设，认真落实党中央治国理政新理念、新思想、新战略，加强党员队伍建设，培养高质量党员队伍，北京中教互联教育科技有限公司立足院校开展党建工作的核心任务和关键方面，依托“党建育人平台”面向全国职业院校全体大学生、入党积极分子、发展对象、预备党员等开展大学生入党启蒙教育、积极分子集中教育、发展对象骨干教育、预备党员锤炼教育等培训工作，以此助力院校高质量推进党的建设工作，为院校提供“数字化党建资源+平台”服务支持，助力院校创新党员培养模式，构建“党建+数字”育人模式，实现为党育人为国育才战略目标，培养有理想、敢担当、能吃苦、肯奋斗的新时代好青年，培育时代新人。</p>",
      swiperOption: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 4,
        // slidesPerGroup: 4,
        spaceBetween: 60,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperData: projectData.swiperData,
      projectList: projectData.projectList,
      categoryData: [],
      courseData: [],
      courseInfo: {
        total: 0,
        total_time: "00:00:00",
      },
      categoryId: "",
      studyBan: false,
    }
  },
  components: {
    Header,
    Footer,
    Aside,
  },
  mounted () {
    utils.setTitle(this.projectList[this.$route.query.index].name)
    this.showHtml = this.background // 默认展示背景
    if (!this.$route.query.index) {
      window.open(`/center/${this.school_code}/custom/party`, "_self")
    }
    this.getCategoryList()
    this.getCourseList()
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    }),
  },
  methods: {
    // jumpList (index) {
    //   let findIndex = this.projectList.findIndex((i, j) => j == index)
    //   window.open(`/center/${this.school_code}/custom/party/project?index=${findIndex}`)
    // },
    // 获取课程分类列表
    getCategoryList () {
      services.getCategoryList({ root_id: 0, school_code: this.school_code, class_name: this.projectList[this.$route.query.index].class_name }).then(res => {
        if (res && res.code == '0000' && res.data && res.data.length > 0) {
          this.categoryData = [{ id: "", name: "全部" }, ...res.data]
        }
      })
    },

    // 获取课程列表
    getCourseList () {
      services.getCourseList({ page: 1, size: 100, school_code: this.school_code, category_id: this.categoryId, class_name: this.projectList[this.$route.query.index].class_name }).then(res => {
        if (res && res.code == '0000' && res.data.items && res.data.items.length > 0) {
          this.courseData = res.data.items
          this.courseInfo.total = res.data.total
          this.courseInfo.total_time = res.data.total_time
        }
      })
    },

    // 切换分类ID
    async currentId (item) {
      this.categoryId = await item.id
      await this.getCourseList()
    },

    // 获取课程章节
    async getCourseChapterDetail (id) {
      if (this.studyBan) return
      await services.getCourseChapterDetail({ id, data: { action: "learn" } }).then(res => {
        if (res.code == '2004') {
          // 判断是否加入班级,没有加入禁止学习
          this.studyBan = true
        }
      })
    },

    // 跳转到课程详情
    async jumpDetail (id) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${id}`, "_blank")
    },
  },
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.h-bg {
    height: auto;
}
@keyframes zoomIn {
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
        opacity: 1;
    }
}

.banner {
    width: 100%;
    height: 664px;
    position: relative;
    .background {
        width: 1200px;
        margin: 0 auto;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        display: flex;
        padding-left: 6px;
        background: url('../../../assets/custom/party/project/index/bg-03.png')
            no-repeat center/cover;
        &::before,
        &::after {
            content: '';
            display: inline-block;
            position: absolute;
            top: -10px;
            width: 122px;
            height: 31px;
            background: url('../../../assets/custom/party/project/index/decorate-01.png')
                no-repeat center/cover;
        }
        &::before {
            left: 118px;
        }
        &::after {
            right: 70px;
        }
        .menu {
            width: 42px;
            margin-right: 26px;
            .menu-item {
                width: 100%;
                height: 172px;
                background: #ebcfac;
                font-weight: bold;
                font-size: 20px;
                color: #ffffff;
                writing-mode: vertical-rl;
                text-align: center;
                line-height: 42px;
                letter-spacing: 5px;
                cursor: pointer;
                &:not(:last-child) {
                    margin-bottom: 2px;
                }
                &.active {
                    background: #b1000e;
                }
            }
        }
        .content {
            padding: 50px 33px 0 0;
            flex: 1;
            position: relative;
            &::before,
            &::after {
                content: '';
                display: inline-block;
                width: 4px;
                height: 21px;
                position: absolute;
                top: 28px;
                background: url('../../../assets/custom/party/project/index/decorate-02.png')
                    no-repeat center/cover;
            }
            &::before {
                left: -10px;
            }
            &::after {
                right: 10px;
            }
            /deep/ p {
                text-indent: 2rem;
                font-size: 16px;
                color: #5e5e5f;
                line-height: 34px;
                &:not(:last-child) {
                    padding-bottom: 10px;
                }
                b {
                    color: #b1000e;
                    font-weight: bold;
                }
            }
        }
    }
}
.container {
    .header {
        width: 964px;
        height: 22px;
        margin: 0 auto;
    }
    .arrange {
        padding: 38px 0 22px;
        background: #fff;
        width: 1200px;
        margin: 0 auto;
        .header {
            background: url('../../../assets/custom/party/project/index/title-01.png')
                no-repeat center/cover;
            margin-bottom: 39px;
        }
        .content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .item {
                width: 250px;
                height: 100px;
                background: url('../../../assets/custom/party/project/index/bg-02.png')
                    no-repeat center/cover;
                display: flex;
                align-items: center;
                padding-left: 20px;
                &:not(:first-child) {
                    border-radius: 4px;
                    position: relative;
                    &::before {
                        content: '';
                        display: inline-block;
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        background: url('../../../assets/custom/party/project/index/step-split.png')
                            no-repeat center/cover;
                        top: 50%;
                        transform: translateY(-50%);
                        left: -43px;
                    }
                }
                .num {
                    font-weight: bold;
                    font-size: 26px;
                    color: #fffefe;
                    margin-right: 19px;
                }
                .info {
                    .name {
                        font-weight: bold;
                        font-size: 17px;
                        color: #fffefe;
                        line-height: 1;
                    }
                    .description {
                        margin-top: 15px;
                        line-height: 1;
                        font-size: 14px;
                        color: #ec9286;
                        position: relative;
                        a {
                            display: inline-block;
                            width: 75px;
                            height: 24px;
                            background: #ffe8b2;
                            text-align: center;
                            line-height: 24px;
                            font-weight: bold;
                            font-size: 14px;
                            color: #b1000e;
                            position: absolute;
                            right: -80px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }
            }
        }
        .bg {
            width: 1200px;
            height: 84px;
            background: url('../../../assets/custom/party/project/index/step-bg.png')
                no-repeat center/cover;
            margin-top: 2px;
        }
    }
    .expert {
        width: 100%;
        height: 596px;
        background: url('../../../assets/custom/party/project/index/bg-01.png')
            no-repeat center/cover;
        padding: 32px 0 0;
        .expert-container {
            width: 1200px;
            margin: 0 auto;
            position: relative;
            .header {
                background: url('../../../assets/custom/party/project/index/title-02.png')
                    no-repeat center/cover;
            }
            .content-swiper {
                /deep/ .swiper-container {
                    .swiper-slide {
                        padding-top: 22px;
                        cursor: default;
                        &:hover {
                            padding-top: 17px;
                            .expert-block {
                                .block-cover {
                                    width: 116px;
                                    height: 125px;
                                }
                                .block-cont {
                                    .cont-body {
                                        .normal-title {
                                            padding-top: 18px;
                                            padding-bottom: 10px;
                                            display: block;
                                            height: 237px;
                                            overflow-y: auto;
                                            text-align: left;
                                            &::-webkit-scrollbar {
                                                width: 5px;
                                                height: 5px;
                                            }

                                            &::-webkit-scrollbar-track-piece {
                                                background: #f7f7f7;
                                            }

                                            &::-webkit-scrollbar-thumb {
                                                background: #bfc2c4;
                                                border-radius: 10px;
                                            }

                                            &::-webkit-scrollbar-corner {
                                                background-color: transparent;
                                            }

                                            &::-webkit-scrollbar-track {
                                                background-color: transparent;
                                            }
                                            .hover-text {
                                                display: block;
                                            }
                                        }
                                    }
                                }
                                .block-name {
                                    margin: 20px 0;
                                }
                            }
                        }
                        .expert-block {
                            text-align: center;

                            * {
                                line-height: 1;
                            }
                            .block-cover {
                                width: 250px;
                                height: 270px;
                                margin: 0 auto;
                                transition: all 0.5s;
                            }
                            .block-name {
                                transition: all 0.5s;
                                font-weight: bold;
                                font-size: 17px;
                                color: #ffffff;
                                margin: 30px 0 20px;
                            }
                            .block-cont {
                                width: 250px;
                                .cont-header {
                                    width: 100%;
                                    height: 62px;
                                    background: #d89f58;
                                    padding-top: 15px;
                                    .cont-school {
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #fdf9f4;
                                        margin-bottom: 8px;
                                    }
                                    .cont-position {
                                        font-size: 12px;
                                        color: #ffffff;
                                        opacity: 0.82;
                                    }
                                }
                                .cont-body {
                                    width: 100%;
                                    .normal-title {
                                        height: 77px;
                                        background: #ffffff;
                                        text-align: center;
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #65262b;
                                        line-height: normal;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: 100%;
                                        padding: 0 14px;
                                        transition: height 0.5s;
                                        span {
                                            line-height: initial;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 2;
                                        }
                                    }
                                    .hover-text {
                                        display: none;
                                        font-size: 12px;
                                        color: #333333;
                                        line-height: 24px;
                                        margin-top: 11px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            /deep/ .swiper-pagination {
                position: absolute;
                top: 58%;
                transform: translateY(-50%);
                right: -52px;
                z-index: 10;
                .swiper-pagination-bullet {
                    display: block;
                    width: 8px;
                    height: 8px;
                    background: rgba(255, 255, 255, 0.4);
                    border-radius: 50%;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-bottom: 10px;
                    }
                    &.swiper-pagination-bullet-active {
                        background: #ffffff;
                    }
                }
            }
            /deep/ .swiper-button-next,
            /deep/ .swiper-button-prev {
                position: absolute;
                top: 112px;
                cursor: pointer;
                z-index: 10;
                width: 36px;
                height: 100px;

                &.swiper-button-disabled {
                    opacity: 0.6;
                }
            }
            /deep/ .swiper-button-next {
                background: url('../../../assets/custom/party/project/index/swiper-next.png')
                    no-repeat center/cover;
                right: -66px;
            }
            /deep/ .swiper-button-prev {
                background: url('../../../assets/custom/party/project/index/swiper-prev.png')
                    no-repeat center/cover;
                left: -66px;
            }
        }
    }
    .course {
        width: 1200px;
        margin: 0 auto;
        padding: 32px 0 10px;
        .header {
            background: url('../../../assets/custom/party/project/index/title-03.png')
                no-repeat center/cover;
            margin-bottom: 17px;
        }
        .collect {
            margin: 0 auto;
            width: 480px;
            height: 27px;
            background: linear-gradient(
                to left,
                #fff,
                rgba(237, 218, 177, 0.24),
                #fff
            );
            margin-bottom: 20px;
            font-size: 12px;
            color: #8e836b;
            text-align: center;
            line-height: 27px;
        }
        .category-list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 17px;
            .item {
                line-height: 1;
                padding: 9px 22px;
                font-size: 14px;
                background: #ffeeee;
                margin-bottom: 10px;
                color: #9c9999;
                cursor: pointer;
                &:hover,
                &.active {
                    color: #ffffff;
                    background: #b1000e;
                }
                &:not(:last-child) {
                    margin-right: 19px;
                }
            }
        }
        .course-list {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .visible {
                display: inline-block;
                flex: 0 0 280px;
                visibility: hidden;
            }
            .item {
                cursor: pointer;
                width: 280px;
                margin-bottom: 27px;
                &:hover {
                    .item-cover {
                        img {
                            transform: scale(1.2);
                        }
                    }
                }
                .item-cover {
                    width: 280px;
                    height: 157px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: transform 0.5s;
                    }
                }
                .item-info {
                    width: 100%;
                    height: 109px;
                    background: #ffffff;
                    border: 1px solid #e2e2e3;
                    padding: 14px 14px 0;
                    .info-title {
                        height: 36px;
                        font-size: 14px;
                        color: #020718;
                        line-height: 18px;
                        margin-bottom: 15px;
                        span {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                        }
                    }
                    .info-other {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .category {
                            width: 145px;
                            height: 24px;
                            background: #fcf6f0;
                            text-align: center;
                            line-height: 24px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-size: 12px;
                            color: #876f46;
                            padding: 0 14px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .time {
                            flex-shrink: 0;
                            font-size: 12px;
                            color: #9199a1;
                            &::before {
                                content: '';
                                display: inline-block;
                                margin-right: 4px;
                                vertical-align: -2px;
                                width: 12px;
                                height: 12px;
                                background: url('../../../assets/custom/party/project/index/icon-time.png')
                                    no-repeat center/cover;
                            }
                        }
                    }
                }
            }
        }
    }
    .about {
        width: 100%;
        height: 120px;
        background: url('../../../assets/custom/party/project/index/bg-04.png')
            no-repeat center/cover;
        .container {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .label {
                width: 42px;
                height: 120px;
                background: #a8000c;
                font-weight: bold;
                font-size: 17px;
                color: #ffffff;
                letter-spacing: 2px;
                writing-mode: vertical-lr;
                text-align: center;
                line-height: 42px;
                margin-right: 26px;
            }
            .content {
                flex: 1;
                display: flex;
                justify-content: space-between;
                a {
                    width: 360px;
                    height: 96px;
                    overflow: hidden;
                    &:hover {
                        img {
                            scale: 1.2;
                        }
                    }
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: scale 0.5s;
                    }
                }
            }
        }
    }
}
.fff {
    background: #fff;
}
</style>


